// ======================================================
// FILE: utils/moduleSelectionHelpers.js
// ======================================================

/*
    This file contains:

    - toggleBaseModule
    - toggleChildModule
    - toggleSubModule
    - toggleAllChildModules
    - toggleAllSubModules
    - calculateTotal
*/




// ======================================================
// TOGGLE BASE MODULE
// ======================================================

// export const toggleBaseModule = (
//     module,
//     formData,
//     setFormData
// ) => {

//     setFormData((prev) => {

//         const exists =
//             prev.subscribedBaseModuleDetails.find(
//                 (item) =>
//                     item.BASEMODULE_ID === module.baseModuleId
//             );

//         // REMOVE
//         if (exists) {

//             return {
//                 ...prev,
//                 subscribedBaseModuleDetails:
//                     prev.subscribedBaseModuleDetails.filter(
//                         (item) =>
//                             item.BASEMODULE_ID !==
//                             module.baseModuleId
//                     )
//             };
//         }

//         // CORE => ONLY ONE CORE
//         let updatedModules =
//             [...prev.subscribedBaseModuleDetails];

//         if (module.baseModuleType === "CORE") {

//             updatedModules =
//                 updatedModules.filter(
//                     (item) => {

//                         const existing =
//                             prev.modules.find(
//                                 (m) =>
//                                     m.baseModuleId ===
//                                     item.BASEMODULE_ID
//                             );

//                         return (
//                             existing?.baseModuleType !==
//                             "CORE"
//                         );
//                     }
//                 );
//         }

//         // ADD
//         updatedModules.push({
//             ID: 0,
//             BASEMODULE_ID: module.baseModuleId,
//             COMPANY_ID: 0,
//             SEATS: 1,
//             CUSTOM_PRICE:
//                 module.baseModuleBasePrice || 0,
//             SUBSCRIBED_BY: "admin",

//             subscribedModuleDetails: []
//         });

//         return {
//             ...prev,
//             subscribedBaseModuleDetails:
//                 updatedModules
//         };
//     });
// };

export const toggleBaseModule = (
    module,
    formData,
    setFormData,
    modules
) => {
    console.log("called -> 1 toggleBaseModule")
    setFormData((prev) => {

        const currentList = prev.SUBSCRIBED_BASEMODULE_DETAILS || [];

        const baseModuleId = module.BASEMODULE_ID;

        const exists = currentList.find(
            (item) => item.BASEMODULE_ID === baseModuleId
        );

        // =========================
        // REMOVE
        // =========================
        if (exists) {
            return {
                ...prev,
                SUBSCRIBED_BASEMODULE_DETAILS: currentList.filter(
                    (item) => item.BASEMODULE_ID !== baseModuleId
                )
            };
        }

        // =========================
        // CORE => ONLY ONE CORE
        // =========================
        let updatedModules = [...currentList];

        if (module.BASEMODULE_TYPE === "CORE") {
            updatedModules = updatedModules.filter((item) => {
                const existing = modules.find(
                    (m) => m.BASEMODULE_ID === item.BASEMODULE_ID
                );

                return existing?.BASEMODULE_TYPE !== "CORE";
            });
        }

        // =========================
        // ADD
        // =========================
        updatedModules.push({
            ID: 0,
            BASEMODULE_ID: baseModuleId,
            COMPANY_ID: 0,
            SEATS: 1,
            CUSTOM_PRICE: module.BASEMODULE_BASEPRICE || 0,
            SUBSCRIBED_BY: "admin",
            SUBSCRIBED_MODULE_DETAILS: []
        });

        return {
            ...prev,
            SUBSCRIBED_BASEMODULE_DETAILS: updatedModules
        };
    });
};


// ======================================================
// TOGGLE CHILD MODULE
// ======================================================

export const toggleChildModule = (
    baseModuleId,
    child,
    formData,
    setFormData
) => {
    console.log("called-> 2 toggleChildModule")
    setFormData((prev) => {

        const updated = (prev.SUBSCRIBED_BASEMODULE_DETAILS || []).map((base) => {

            if (base.BASEMODULE_ID !== baseModuleId) {
                return base;
            }

            const existingList = base.SUBSCRIBED_MODULE_DETAILS || [];

            const childId = child.MODULE_ID;

            const exists = existingList.find(
                (item) => item.MODULE_ID === childId
            );

            // =========================
            // REMOVE CHILD MODULE
            // =========================
            if (exists) {
                return {
                    ...base,
                    SUBSCRIBED_MODULE_DETAILS: existingList.filter(
                        (item) => item.MODULE_ID !== childId
                    )
                };
            }

            // =========================
            // ADD CHILD MODULE
            // =========================
            return {
                ...base,
                SUBSCRIBED_MODULE_DETAILS: [
                    ...existingList,
                    {
                        ID: 0,
                        MODULE_ID: childId,
                        COMPANY_ID: 0,
                        SEATS: 1,
                        CUSTOM_PRICE: child.MODULE_BASEPRICE || 0,
                        SUBSCRIBED_BY: "admin",
                        SUBSCRIBED_SUBMODULE_DETAILS: []
                    }
                ]
            };
        });

        return {
            ...prev,
            SUBSCRIBED_BASEMODULE_DETAILS: updated
        };
    });
};



// ======================================================
// TOGGLE SUB MODULE
// ======================================================

export const toggleSubModule = (
    baseModuleId,
    moduleId,
    sub,
    formData,
    setFormData
) => {

    setFormData((prev) => {

        const updated = (prev.SUBSCRIBED_BASEMODULE_DETAILS || []).map(
            (base) => {

                if (base.BASEMODULE_ID !== baseModuleId) {
                    return base;
                }

                return {
                    ...base,

                    SUBSCRIBED_MODULE_DETAILS: (base.SUBSCRIBED_MODULE_DETAILS || []).map(
                        (child) => {

                            if (child.MODULE_ID !== moduleId) {
                                return child;
                            }

                            const existingList =
                                child.SUBSCRIBED_SUBMODULE_DETAILS || [];

                            const exists = existingList.find(
                                (item) =>
                                    item.SUBMODULE_ID === sub.SUBMODULE_ID
                            );

                            // REMOVE
                            if (exists) {
                                return {
                                    ...child,
                                    SUBSCRIBED_SUBMODULE_DETAILS:
                                        existingList.filter(
                                            (item) =>
                                                item.SUBMODULE_ID !== sub.SUBMODULE_ID
                                        )
                                };
                            }

                            // ADD
                            return {
                                ...child,
                                SUBSCRIBED_SUBMODULE_DETAILS: [
                                    ...existingList,
                                    {
                                        ID: 0,
                                        SUBMODULE_ID: sub.SUBMODULE_ID,
                                        COMPANY_ID: 0,
                                        SEATS: 1,
                                        CUSTOM_PRICE: sub.SUBMODULE_BASEPRICE || 0,
                                        SUBSCRIBED_BY: "admin"
                                    }
                                ]
                            };
                        }
                    )
                };
            }
        );

        return {
            ...prev,
            SUBSCRIBED_BASEMODULE_DETAILS: updated
        };
    });
};



// ======================================================
// TOGGLE ALL CHILD MODULES
// ======================================================

export const toggleAllChildModules = (
    module,
    formData,
    setFormData
) => {

    setFormData((prev) => {

        const updated = (prev.SUBSCRIBED_BASEMODULE_DETAILS || []).map(
            (base) => {

                if (base.BASEMODULE_ID !== module.BASEMODULE_ID) {
                    return base;
                }

                const existingModules = base.SUBSCRIBED_MODULE_DETAILS || [];

                const allSelected =
                    existingModules.length === (module.MODULES_DATA?.length || 0);

                // =========================
                // REMOVE ALL
                // =========================
                if (allSelected) {
                    return {
                        ...base,
                        SUBSCRIBED_MODULE_DETAILS: []
                    };
                }

                // =========================
                // ADD ALL
                // =========================
                return {
                    ...base,

                    SUBSCRIBED_MODULE_DETAILS: (module.MODULES_DATA || []).map(
                        (child) => ({
                            ID: 0,
                            MODULE_ID: child.MODULE_ID,
                            COMPANY_ID: 0,
                            SEATS: 1,
                            CUSTOM_PRICE: child.MODULE_BASEPRICE || 0,
                            SUBSCRIBED_BY: "admin",
                            SUBSCRIBED_SUBMODULE_DETAILS: []
                        })
                    )
                };
            }
        );

        return {
            ...prev,
            SUBSCRIBED_BASEMODULE_DETAILS: updated
        };
    });
};




// ======================================================
// TOGGLE ALL SUB MODULES
// ======================================================

export const toggleAllSubModules = (
    baseModuleId,
    module,
    formData,
    setFormData
) => {

    setFormData((prev) => {

        const updated = (prev.SUBSCRIBED_BASEMODULE_DETAILS || []).map(
            (base) => {

                if (base.BASEMODULE_ID !== baseModuleId) {
                    return base;
                }

                return {
                    ...base,

                    SUBSCRIBED_MODULE_DETAILS: (base.SUBSCRIBED_MODULE_DETAILS || []).map(
                        (child) => {

                            if (child.MODULE_ID !== module.MODULE_ID) {
                                return child;
                            }

                            const existingSubs =
                                child.SUBSCRIBED_SUBMODULE_DETAILS || [];

                            const allSelected =
                                existingSubs.length === (module.SUBMODULES_DATA?.length || 0);

                            // =========================
                            // REMOVE ALL
                            // =========================
                            if (allSelected) {
                                return {
                                    ...child,
                                    SUBSCRIBED_SUBMODULE_DETAILS: []
                                };
                            }

                            // =========================
                            // ADD ALL
                            // =========================
                            return {
                                ...child,

                                SUBSCRIBED_SUBMODULE_DETAILS: (module.SUBMODULES_DATA || []).map(
                                    (sub) => ({
                                        ID: 0,
                                        SUBMODULE_ID: sub.SUBMODULE_ID,
                                        COMPANY_ID: 0,
                                        SEATS: 1,
                                        CUSTOM_PRICE: sub.SUBMODULE_BASEPRICE || 0,
                                        SUBSCRIBED_BY: "admin"
                                    })
                                )
                            };
                        }
                    )
                };
            }
        );

        return {
            ...prev,
            SUBSCRIBED_BASEMODULE_DETAILS: updated
        };
    });
};




// ======================================================
// CALCULATE TOTAL
// ======================================================

export const calculateTotal = (
    subscribedBaseModuleDetails = []
) => {

    let total = 0;

    subscribedBaseModuleDetails.forEach(
        (base) => {

            total += Number(base.CUSTOM_PRICE || 0);

            base.SUBSCRIBED_MODULE_DETAILS?.forEach(
                (child) => {

                    // total += Number(
                    //     child.CUSTOM_PRICE || 0
                    // );

                    child.SUBSCRIBED_SUBMODULE_DETAILS?.forEach(
                        (sub) => {

                            total += Number(
                                sub.CUSTOM_PRICE || 0
                            );
                        }
                    );
                }
            );
        }
    );

    return total;
};